<template>
  <section v-if="selfReview || criticReview" class="tile is-ancestor">
    <div class="tile is-parent">
      <div class="tile is-child box">
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <slot name="title" />
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <b-button
                class="is-primary is-small"
                :loading="isCriticReviewModalOpen"
                @click="addOrUpdateCriticReview"
                >{{ criticReview ? 'Update' : 'Add' }} Critic Review</b-button
              >
            </div>
          </div>
        </div>
        <div class="tile is-ancestor criterion">
          <div class="tile is-parent criterion-row">
            <div class="tile is-child criterion-item">
              <p class="title is-6">Criteria</p>
            </div>
            <div v-if="selfReview" class="tile is-child criterion-item">
              <p class="title is-6">Self Review</p>
            </div>
            <div v-if="criticReview" class="tile is-child criterion-item">
              <p class="title is-6">Critic Review</p>
            </div>
          </div>
        </div>
        <div
          v-for="criterion in criteria"
          :key="criterion.key"
          class="tile is-ancestor criterion"
        >
          <div class="tile is-parent criterion-row">
            <div class="tile is-child criterion-item">
              <b-field :label="criterion['description']">
                <div class="media">
                  <div class="media-content">
                    <p class="subtitle is-7">Weight</p>
                    <p class="title is-6">{{ criterion.weight }}</p>
                  </div>
                  <div class="media-content">
                    <p class="subtitle is-7">Justify</p>
                    <p
                      class="title is-6"
                      :class="[
                        criterion.justify
                          ? 'has-text-success'
                          : 'has-text-warning'
                      ]"
                    >
                      {{ criterion.justify ? 'Yes' : 'No' }}
                    </p>
                  </div>
                </div>
              </b-field>
            </div>
            <div v-if="selfReview" class="tile is-child criterion-item">
              <review-item
                :total-weigth="totalWeigth"
                :weight="criterion.weight"
                :review="extractReviewForKey(selfReview, criterion.key)"
              />
            </div>
            <div v-if="criticReview" class="tile is-child criterion-item">
              <review-item
                :total-weigth="totalWeigth"
                :weight="criterion.weight"
                :review="extractReviewForKey(criticReview, criterion.key)"
              />
            </div>
          </div>
        </div>
        <div class="tile is-ancestor criterion">
          <div class="tile is-parent criterion-row">
            <div class="tile is-child criterion-item">
              <b-field label="Bonus">
                <div class="media">
                  <div class="media-content">
                    <p class="subtitle is-7">Weight</p>
                    <p class="title is-6">{{ totalWeigth }}</p>
                  </div>
                  <div class="media-content">
                    <p class="subtitle is-7">Justify</p>
                    <p class="title is-6 has-text-success">Yes</p>
                  </div>
                </div>
              </b-field>
            </div>
            <div v-if="selfReview" class="tile is-child criterion-item"></div>
            <div v-if="criticReview" class="tile is-child criterion-item">
              <div class="review-item">
                <div class="level">
                  <div class="level-left">{{ criticReview.ratings.bonus }}</div>
                  <div class="level-right">
                    <b-field label="Score">
                      <p class="title is-6">
                        {{ criticReview.ratings.bonus }}/{{ 2 * totalWeigth }}
                      </p>
                    </b-field>
                  </div>
                </div>
                <b-field label="Comment">
                  <p class="subtitle is-6">
                    {{ criticReview.comments.bonus || 'no comments' }}
                  </p>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <update-critic-review-modal
      ref="criticReviewPanel"
      :open="isCriticReviewModalOpen"
    />
  </section>
</template>

<script>
import ReviewItem from './ReviewItem';
import UpdateCriticReviewModal from './UpdateCriticReviewModal';

export default {
  components: {
    ReviewItem,
    UpdateCriticReviewModal
  },
  props: {
    reviews: {
      type: Object,
      required: true
    },
    criteria: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isCriticReviewModalOpen: false
    };
  },
  computed: {
    selfReview() {
      return this.reviews['self'];
    },
    criticReview() {
      return this.reviews['critic'];
    },
    totalWeigth() {
      return this.criteria.reduce(
        (sum, criterion) => sum + criterion.weight,
        0
      );
    }
  },
  methods: {
    extractReviewForKey(review, key) {
      return {
        rating: review['ratings'][key],
        comment: review['comments'][key],
        score: review['scores'][key]
      };
    },
    openUpdateCriticReviewPanel() {
      return new Promise((resolve, reject) => {
        const criticReviewPanel = this.$refs.criticReviewPanel;
        const handler = returnPromiseFn => () => {
          criticReviewPanel.$off('input', handler);
          criticReviewPanel.$off('close', handler);
          this.isCriticReviewModalOpen = false;
          returnPromiseFn();
        };
        criticReviewPanel.$on('input', handler(resolve));
        criticReviewPanel.$on('close', handler(reject));
        this.isCriticReviewModalOpen = true;
      });
    },
    async addOrUpdateCriticReview() {
      try {
        await this.openUpdateCriticReviewPanel();
        this.$buefy.toast.open({
          message: 'success fully updated Critic Review.',
          type: 'is-success'
        });
      } catch (e) {
        // eslint-disable-next-line
        console.log(e);
        this.$buefy.toast.open({
          message: 'Review update canceled!',
          type: 'is-danger'
        });
      }
    }
  }
};
</script>

<style lang="scss">
.criterion {
  &:not(:last-child) {
    .criterion-row {
      -webkit-box-shadow: 0 2px 2px 0 rgba(204, 204, 204, 0.5);
      box-shadow: 0 1px 0px 0 rgba(204, 204, 204, 0.5);
    }
  }
  .criterion-row {
    margin: 0.5em 0;

    .criterion-item {
      padding: 0 0.5em;
    }
  }
}
</style>
